export default "__VITE_ASSET__ByFk0uWz__"